import { readAdvertisingConsent } from "@/lib/readAdvertisingConsent";
import { setGoogleConsent } from "@/lib/setGoogleConsent";
import { GOOGLE_ADS_TAG_ID, GOOGLE_ANALYTICS_MEASUREMENT_ID } from "@/lib/tracking-constants";

import { sanitizeAnalyticsUrl } from "./sanitize-analytics-url";

let configured = false;

/** Configures the Cloudflare-loaded tag once after hydration. */
export function configureGoogleTag(): void {
  if (process.env.NODE_ENV !== "production") return;
  if (typeof window === "undefined" || typeof window.gtag !== "function" || configured) return;

  setGoogleConsent(readAdvertisingConsent() ?? "denied", "default");

  const pageLocation = sanitizeAnalyticsUrl(window.location.href);
  window.gtag("config", GOOGLE_ANALYTICS_MEASUREMENT_ID, { page_location: pageLocation });
  window.gtag("config", GOOGLE_ADS_TAG_ID, { page_location: pageLocation });
  configured = true;
}
